import { ScreenElement, Sprite } from "excalibur";
import { Resources } from "../resources";
import { LevelOne } from "../scenes/level-one/level-one";

export class MapBackground extends ScreenElement {
    constructor(private level: LevelOne) {
        const height = level.engine.drawHeight - level.engine.drawHeight / 4;
        const width = height * 16 / 9;
        super({
            width,
            height,
            z: -100
        });
    }

    onInitialize() {
        this.graphics.use(
            new Sprite({
                image: Resources.map,
                destSize: {
                    width: this.width,
                    height: this.height
                }
            })
        )
    }
}